(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bb-model-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  if (event.target.closest('[data-bb-model-info-open]')) {
    event.target.closest('.bb-model-info').nextElementSibling?.showModal();
  }
  if (event.target.closest('[data-bb-model-info-close]')) {
    event.target.closest('dialog')?.close();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bb-tab-group"] && !Shopify.designMode) return;
  try {
    class BBTabGroup extends HTMLElement {
  connectedCallback() {
    const navButtons = Array.from(this.querySelectorAll('[data-bb-tab-nav]'));
    if (navButtons.length && !this.querySelector('.bb-tab-group__nav')) {
      const navWrapper = document.createElement('div');
      navWrapper.className = 'bb-tab-group__nav';
      navButtons.forEach((btn) => navWrapper.appendChild(btn));
      this.insertBefore(navWrapper, this.firstChild);
    }

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bb-tab-nav]');
      if (!button || !this.contains(button)) return;
      const allButtons = Array.from(this.querySelectorAll('[data-bb-tab-nav]'));
      const allPanels = Array.from(this.querySelectorAll('[data-bb-tab-body]'));
      const index = allButtons.indexOf(button);
      const panel = allPanels[index];

      allButtons.forEach((el) => el.setAttribute('aria-selected', 'false'));
      allPanels.forEach((el) => (el.hidden = true));
      button.setAttribute('aria-selected', 'true');
      if (panel) panel.hidden = false;
      button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });

    const firstNav = this.querySelector('[data-bb-tab-nav]');
    const firstBody = this.querySelector('[data-bb-tab-body]');
    if (firstNav) firstNav.setAttribute('aria-selected', 'true');
    if (firstBody) firstBody.hidden = false;
  }
}
customElements.define('bb-tab-group', BBTabGroup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
  'click',
  (event) => {
    const disabledInput = event.target.closest?.('label')?.querySelector?.('input[aria-disabled="true"]');

    if (!disabledInput) return;

    event.preventDefault();
    event.stopPropagation();
  },
  true
);

document.addEventListener(
  'change',
  (event) => {
    const input = event.target;

    if (input?.matches?.('input[aria-disabled="true"]')) {
      input.checked = false;
      event.preventDefault();
      event.stopPropagation();
    }
  },
  true
);

class BBPairedSwatches extends HTMLElement {
  connectedCallback() {
    const dataEl = this.querySelector('[data-bb-paired-swatches-data]');
    if (!dataEl) return;

    try {
      this.data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    this.items = Array.from(this.querySelectorAll('[data-bb-paired-swatch]'));

    const picker = document.querySelector('variant-picker[data-template-product-match="true"]');
    if (!picker) return;

    picker.addEventListener('change', (event) => {
      const input = event.target;
      if (input?.dataset?.optionName?.toLowerCase() === 'size') {
        this._updateLinks(input.value);
      }
    });
  }

  _updateLinks(sizeValue) {
    const { variants, sizePosition, colourPosition, productUrl } = this.data;
    const optionKey = (pos) => `option${pos}`;

    this.items.forEach((item) => {
      const colourValue = item.dataset.colourValue;

      let matched = variants.find(
        (v) => v[optionKey(colourPosition)] === colourValue && v[optionKey(sizePosition)] === sizeValue
      );

      if (!matched) {
        matched =
          variants.find((v) => v[optionKey(colourPosition)] === colourValue && v.available) ||
          variants.find((v) => v[optionKey(colourPosition)] === colourValue);
      }

      if (matched) {
        item.href = `${productUrl}?variant=${matched.id}`;
      }
    });
  }
}
customElements.define('bb-paired-swatches', BBPairedSwatches);
  } catch(e) { console.error(e); }
})();

})();
